import { Collection } from 'modules/core/lib/mobx-rest'

import CompanySettingsVersion from 'modules/attendance/store/models/CompanySettingsVersion'

class CompanySettingsVersions extends Collection<CompanySettingsVersion> {
  get cacheKey(): string {
    return 'companySettingsVersions'
  }

  model() {
    return CompanySettingsVersion
  }
}

export default new CompanySettingsVersions()
